import React, {useState, useEffect, useRef} from 'react';
import { useSelector } from 'react-redux';
import { Wrapper } from './style';

// Component
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SearchInput from 'components/common/SearchInput';

// Libs && configs
import Translation from 'libs/Translation';

const Selection = ({ list, valueKey, labelKey, labelKeyByLang, icon, handleSelect, value, name, style, listStyle, selectStyle, freeTimeCalendar, width50, handleChange, searchKey, searchValue, searchBox }) => {
  const [showOptionList, setShowOptionList] = useState(false);
  const wrapperRef = useRef(null);
  const { webConfig } = useSelector(state => state.core);
  let finalLabelKey = labelKey;
  if (labelKeyByLang) {
   if (webConfig.lang !== 'fa') {
    finalLabelKey = labelKeyByLang;
   }
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
       setShowOptionList(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);


  const handleListDisplay = () => {
    setShowOptionList(!showOptionList);
  }

  const handleOptionClick = (name, label, value) => {
    handleSelect(name, label, value);
    handleListDisplay();
  }

	return (
    <Wrapper 
      webConfig={webConfig}
      style={style}
      freeTimeCalendar={freeTimeCalendar}
      width50={width50}
    >
      <div 
        className="custom-select-container"
        ref={wrapperRef}
        onClick={handleListDisplay}
      >
        {showOptionList && searchBox &&
        <SearchInput
          name={searchKey}      
          className='input'
          handleChange={handleChange}
          defaultValue={searchValue}
          autoFocus={true}
          placeholder={Translation.t(`label.${name}`)}
          mr="0"
        />
        }
        <div
          className={showOptionList ? "selected-text active" : "selected-text"}
          style={selectStyle}
        >
          <div className='text'>
            {icon && icon}
            {searchBox && showOptionList ? null : value}
          </div>
          {showOptionList
          ?
          <ExpandLessIcon className='icon'/>
          :
          <ExpandMoreIcon className='icon'/>
          }
        
        </div>
        {showOptionList && (
          <ul 
            className="select-options"
            style={listStyle}
          >
            {list?.map(option => {
              return (
                <li
                  className={value === option[finalLabelKey] ? "selected custom-select-option": "custom-select-option"}
                  data-name={option[valueKey]}
                  key={option[valueKey]}
                  onClick={() => handleOptionClick(name, option[finalLabelKey], option[valueKey])}
                >
                  {option[finalLabelKey]}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </Wrapper>
	);
};

export default Selection;